import ClientConnectsProgressBar from './ClientConnectsProgressBar.container';

export default ClientConnectsProgressBar;
